module.exports = __webpack_public_path__ + "img/parking-a.efcad741.png";